import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { change } from 'redux-form';

import { FlexRow } from 'components/Shared/Scaffolding';
import { Input, Slider } from 'components/Shared/Forms';
import { SCAFFOLDING, SETTINGS_INPUTS } from 'theme';
import { hasValue, required } from 'utils/validation';
import { formName } from 'modules/markers';
import IconUpload from 'components/MarkerSettings/IconUpload';
import Collapse from 'components/Shared/Collapse';
import { SettingsHelper } from 'components/Shared/SettingsGroup';

const StyledContainer = styled.div`
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SETTINGS_INPUTS.PADDING.X};
    background-color: ${SETTINGS_INPUTS.BG.SUB};
`;

const StyledCollapse = styled(Collapse)`
    > * {
        padding-top: ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    }
`;

class IconCustom extends React.Component {
    handleImageChange = (image) => {
        this.updateIcon(
            image && hasValue(image.width) ? image.width : 36,
            image && hasValue(image.height) ? image.height : 36
        );
    };

    updateIcon = (width, height) => {
        const { onChange } = this.props;
        onChange(formName, 'icon.width', width);
        onChange(formName, 'icon.height', height);
        onChange(formName, 'icon.anchorX', Math.round(width / 2));
        onChange(formName, 'icon.anchorY', height);
    };

    handleWidthChange = (e, width) => {
        const { anchor, size } = this.props;
        this.updateSliderValue(anchor.x, 'icon.anchorX', size.width, width);
    };

    handleHeightChange = (e, height) => {
        const { anchor, size } = this.props;
        this.updateSliderValue(anchor.y, 'icon.anchorY', size.height, height);
    };

    updateSliderValue = (value, property, oldMax, newMax) => {
        if (!hasValue(oldMax)) return;
        const { onChange } = this.props;
        const slider = this.getScaledValue(value, oldMax, newMax);
        onChange(formName, property, slider);
    };

    getScaledValue = (value, oldMax, newMax) => {
        if (oldMax === 0) return 0;
        const percent = value / oldMax;
        const newValue = newMax * percent;
        return Math.round(newValue);
    };

    render() {
        const { anchor, size, image } = this.props;
        return (
            <StyledContainer>
                <SettingsHelper>
                    Upload an image that you would like to use for your marker icon. We support .gif, .jpg, .png, and
                    .svg files up to 3 MB. For SVGs, we only support a single path.
                </SettingsHelper>
                <IconUpload
                    name="image"
                    label="Image File"
                    url="/build-a-map/upload-marker-icon"
                    size={size}
                    anchor={anchor}
                    onChange={this.handleImageChange}
                    validate={required}
                />
                <StyledCollapse isOpened={!!image}>
                    <FlexRow>
                        <Input
                            name="width"
                            type="int"
                            label="Width"
                            width="50%"
                            unitAfter="px"
                            min={0}
                            required
                            deferred
                            onChange={this.handleWidthChange}
                        />
                        <Input
                            name="height"
                            type="int"
                            label="Height"
                            width="50%"
                            unitAfter="px"
                            min={0}
                            required
                            deferred
                            onChange={this.handleHeightChange}
                        />
                    </FlexRow>
                    <Slider
                        name="anchorX"
                        label="Anchor X Coordinate"
                        min={0}
                        max={hasValue(size.width) ? size.width : 36}
                        unitAfter="px"
                    />
                    <Slider
                        name="anchorY"
                        label="Anchor Y Coordinate"
                        min={0}
                        max={hasValue(size.height) ? size.height : 36}
                        unitAfter="px"
                    />
                </StyledCollapse>
            </StyledContainer>
        );
    }
}

const mapDispatchToProps = {
    onChange: change,
};

export default connect(null, mapDispatchToProps)(IconCustom);
